/**
 * App entrypoint.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter } from 'react-router-dom'
import App from './App.js'
import { ErrorBoundary } from './components/error-boundary.js'
import './index.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

// Toast container lives on <body> as a sibling of #root so it escapes the
// React tree and can sit above <dialog> modal backdrops (which use the
// browser's top layer and ignore z-index of descendants).
const toastContainer = document.createElement('div')
toastContainer.id = 'toast-root'
document.body.appendChild(toastContainer)
const toastRoot = createRoot(toastContainer)
toastRoot.render(
  <Toaster
    position="top-right"
    gutter={8}
    containerStyle={{ zIndex: 2147483647 }}
    toastOptions={{
      style: { fontSize: '14px' },
      duration: 4000,
    }}
  />,
)

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
